// extracted by mini-css-extract-plugin
export var dropdownContainer = "_54-5";
export var imageContainer = "_54-4";
export var metricsGrid = "_54-2";
export var productDetailContainer = "_54-1";
export var productListContainer = "_54-0";
export var subscriberTableContainer = "_54-3";